export const CREATE_QUICKLINK_REQUEST = 'CREATE_QUICKLINK_REQUEST'
export const CREATE_QUICKLINK_SUCCESS = 'CREATE_QUICKLINK_SUCCESS'
export const CREATE_QUICKLINK_FAILURE = 'CREATE_QUICKLINK_FAILURE'
export const UPDATE_QUICKLINK_REQUEST = 'UPDATE_QUICKLINK_REQUEST'
export const UPDATE_QUICKLINK_SUCCESS = 'UPDATE_QUICKLINK_SUCCESS'
export const UPDATE_QUICKLINK_FAILURE = 'UPDATE_QUICKLINK_FAILURE'